<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="columns columns--full is-vcentered onboarding-create-site__step2">
    <div class="column has-text-centered onboarding-create-site__description">
      <h1
        v-if="content.step1.answer"
        class="onboarding-create-site__title"
        v-html="content.step1.answer.answer"
      ></h1>
    </div>
  </div>
</template>

<script>
import verifyOnboardingCompleteMixin from '@/mixins/verifyOnboardingCompleteMixin'

export default {
  mixins: [verifyOnboardingCompleteMixin],

  mounted() {
    setTimeout(this.nextStep, 2000)
  },

  props: {
    stepNumber: Number,
    content: Object,
  },

  methods: {
    nextStep() {
      this.$router.push({
        path: `/onboarding/passo-${this.stepNumber}`,
      })
    },
  },
}
</script>

<style lang="scss"></style>
